<template>
  <qx-card title="员工列表">
    <ChooseWorker ref="chooseWorker" @change="handleUserChange" :customShow="true" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1100302">
        <el-button type="primary" plain @click="showUserDialog">添加员工</el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
<!--          <el-table-column prop="control" label="操作1" width="120" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              <section>-->
<!--                &lt;!&ndash; 操作按钮 &ndash;&gt;-->
<!--                <qx-permpisions permpisions="1100304">-->
<!--                  <span class="primary cur" @click="del(scope.row.userId)">删除</span>-->
<!--                </qx-permpisions>-->
<!--              </section>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ChooseWorker from 'components/choose/worker';
import {
  orgUserList,
  orgUserAdd,
  orgUserDel,
} from 'api/system';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ChooseWorker,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'loginAcct',
            label: '登录手机',
          },
          {
            prop: 'linkman',
            label: '员工姓名',
          },
          {
            prop: 'staffPosition',
            label: '职位',
          },
          {
            prop: 'createDate',
            label: '加入时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orgUserList,
    showUserDialog () {
      this.$refs.chooseWorker.show();
    },
    async handleUserChange (data) {
      const userIds = data.map((item) => item.userId);
      const res = await orgUserAdd({
        orgId: this.searchBoxData.orgId,
        userIds: userIds.join(','),
      });
      if (!res.failed) {
        this.$message.success('添加成功');
        this.getData();
      }
    },
    async del (userId) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await orgUserDel({
          userIds: userId,
          orgId: this.searchBoxData.orgId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
